export default __webpack_public_path__ + "static/media/Hand_left.73416fb9.svg";